import PropTypes from "prop-types";
import { WineEvents } from "vino/components";

const Block = ({ attributes }) => {
	return <WineEvents attributes={attributes} />;
};

Block.propTypes = {
	attributes: PropTypes.object,
};

export default Block;
